// eslint-disable-next-line
import React, { useState } from "react";
import { useEthers } from "@usedapp/core";
import { useDispatch } from "react-redux";
import { setCurrentAccount } from "../state/wallet";
import { UnsupportedChainIdError, useWeb3React } from "web3-react-core";
import { injected } from "../connectors";
import { initializeChain } from "../helper";
import { encode } from "js-base64";
import { web3 } from "../utils/web3";
import { setSignMessage, setDialogWallet, setTicket } from "../state/actions";
import { verifyService } from "../services";
import _ from "lodash";

export const useConnectWallet = () => {
  const { account, active, deactivate } = useEthers();
  const dispatch = useDispatch();

  const handleConnect = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert("Get MetaMask!");
        return;
      }

      const accounts = await ethereum.request({
        method: "eth_requestAccounts"
      });

      dispatch(setCurrentAccount(accounts[0]));
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
    }
  };

  return { onConnect: handleConnect, account, active, deactivate };
};

export const connectWallet = () => {
  const { activate } = useWeb3React();

  const handleConnect = async (onDismiss?: any, wallet?: string) => {
    if (wallet === "METAMASK") {
      activate(injected, undefined, true)
        .then(async () => {
          localStorage.setItem("isWalletConnected", "connected");
          onDismiss;
        })
        .catch((error) => {
          if (error instanceof UnsupportedChainIdError) {
            activate(injected);
          } else {
            console.error(error);
          }
        });
    } else if (wallet === "KEPLR") {
      initializeChain((error: any, addressList: any) => {
        if (error) {
          localStorage.removeItem("z_address");

          return;
        }

        localStorage.setItem(
          "z_address",
          encode(addressList[0] && addressList[0].address)
        );
        onDismiss;
        setCurrentAccount(addressList[0]);
      });
    }
  };
  return { onConnect: handleConnect };
};

export const signMessage = () => {
  const { activate } = useWeb3React();
  const dispatch = useDispatch();
  const [signature, setSignature] = useState(localStorage.getItem("s"));

  const handleSignMessage = async (
    whitelistId?: string,
    ticketGen?: Boolean,
    setIsLoading?: any
  ) => {
    activate(injected, undefined, true)
      .then(async () => {
        const walletAddress = await injected.getAccount();
        localStorage.setItem("isWalletConnected", "connected");
        if (ticketGen) {
          if(setIsLoading){
            setIsLoading(true)
          }
          
          const signs = await web3.eth.personal.sign(
            'GET TICKET',
            walletAddress
          );

          await verifyService
            .getQrcode(whitelistId || "", signs)
            .then((res) => {
              const data = _.get(res, "data.data");
              dispatch(setTicket(data.ticketId));
              if(setIsLoading){
              setIsLoading(false)}
            })
            .catch((err) => {
              if(setIsLoading){
              setIsLoading(false)}
              console.error(err);
            });
        } else {
          const signM = await web3.eth.personal.sign(
            web3.utils.sha3("register"),
            walletAddress
          );
          setSignature(encode(signM));
          dispatch(setSignMessage(encode(signM)));
          localStorage.setItem("s", encode(signM));
          dispatch(setDialogWallet(false));
        }
      })
      .catch((error) => {
        dispatch(setDialogWallet(false));
        if (error instanceof UnsupportedChainIdError) {
          activate(injected);
        } else {
          console.error(error);
        }
      });
  };
  return { sign: handleSignMessage, signature, setSignature };
};
